import { connect } from 'react-redux';
import { compose } from 'ramda';
import { withRouter } from 'react-router-dom';
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import Container from './Container';

const enhance = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(Container);
